import { render, staticRenderFns } from "./Recitals.vue?vue&type=template&id=76149b10"
import script from "./Recitals.vue?vue&type=script&lang=js"
export * from "./Recitals.vue?vue&type=script&lang=js"
import style0 from "./Recitals.vue?vue&type=style&index=0&id=76149b10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports